import axios from 'axios';
import {
    Message
} from 'element-ui';
import Vue from 'vue';

let baseURL = process.env.VUE_APP_URL;
const instance = axios.create({
    baseURL: baseURL,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8,multipart/form-data'
    },
    validateStatus(status) {
        switch (status) {
            case 400:
                Message.error('请求出错');
                break;
            case 401:
                Message.warning({
                    message: '授权失败'
                });
                break;
            case 403:
                Message.warning({
                    message: '拒绝访问'
                });
                break;
            case 404:
                Message.warning({
                    message: '未找到请求的资源'
                });
                break;
            case 500:
                Message.warning({
                    message: '服务端错误'
                })
                break;
        }
        return status >= 200 && status < 300;
    }
});


let isLoading = false;
let loading;
// 显示加载中
function showLoading() {
    if (isLoading)
        return;
    loading = Vue.prototype.$loading({
        lock: true,
        text: '努力加载中...',
        background: 'rgba(0,0,0,0.5)',
        target: document.querySelector('.content-container') // 设置加载动画区域
    });
    isLoading = true;
}

let requestCount = 0 // 请求计数
// 开始请求计数
function addRequest() {
    requestCount++;
    showLoading();
}
// 结束请求计数
function endRequest() {
    if (requestCount > 0)
        requestCount--;
    if (requestCount < 1 && isLoading) {
        loading.close();
        isLoading = false;
    }
}

// 添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        config.headers['Access-Control-Allow-Origin: *']; //允许所有域名的脚本访问该资源。
        config.headers['Access-Control-Allow-Headers: Origin, X-Requested-With, Content-Type, Accept']; //表明允许跨域请求包含content-type头
        config.headers['Access-Control-Allow-Methods: POST,GET']; //请求方式
        // addRequest();
        return config;
    },
    function (error) {
        // endRequest();
        console.log(error);
        return Promise.reject(error);
    }
)

// 添加响应拦截器
instance.interceptors.response.use(
    function (response) {
        // endRequest();
        return response.data;
    },
    error => {
        // endRequest();
        console.log('err:' + error);
        return Promise.reject(error);
    }
)

export default instance;